export function formatPhoneForDisplay(value: string | null | undefined): string | null | undefined {
  if (value == null) {
    return value
  }

  const trimmed = value.trim()
  if (!trimmed) {
    return trimmed
  }

  let digits = trimmed.replace(/\D/g, '')
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1)
  }

  if (digits.length !== 10) {
    return trimmed
  }

  const area = digits.slice(0, 3)
  const prefix = digits.slice(3, 6)
  const line = digits.slice(6)

  return `(${area}) ${prefix}-${line}`
}
